interface IPersonDisplay {
  firstName?: string
  lastName?: string
  username?: string
  emailAddress?: string
}

export const getInitials = (people: IPersonDisplay): string => {
  if (people?.firstName && people?.lastName) {
    return (
      people.firstName.charAt(0).toUpperCase() +
      people.lastName.charAt(0).toUpperCase()
    )
  }

  if (people?.username) {
    const names = people.username.split(' ')
    return (
      names[0].charAt(0).toUpperCase() +
      (names[1]?.charAt(0).toUpperCase() || '')
    )
  }

  return people?.emailAddress?.charAt(0).toUpperCase() ?? ''
}

export const abbreviation = (fullName: string): string => {
  const names = fullName?.split(' ') ?? []
  return (
    (names[0]?.[0]?.toUpperCase() ?? '') + (names[1]?.[0]?.toUpperCase() ?? '')
  )
}

// Background colours for an initials avatar. Every entry keeps white initials
// at WCAG AA contrast (>= 4.5:1), so any name can land on any colour.
export const AVATAR_COLORS = [
  '#1b3380',
  '#5e35b1',
  '#0f7b6c',
  '#c2185b',
  '#bf360c',
  '#2e7d32',
  '#6a1b9a',
  '#006064',
  '#ad1457',
  '#4527a0',
] as const

// Deterministic: the same name always gets the same colour, across renders,
// sessions and screens, without storing anything.
export const getAvatarColor = (name?: string): string => {
  const source = name?.trim().toLowerCase() ?? ''
  let hash = 0
  for (let i = 0; i < source.length; i++) {
    hash = (hash * 31 + source.charCodeAt(i)) | 0
  }
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length]
}

export const userUtil = {getInitials, abbreviation, getAvatarColor} as const
